import type { en } from "./messages/en";

/** The locales the console ships with. */
export const LOCALE_CODES = ["en", "ru", "kk", "es"] as const;

export type Locale = typeof LOCALE_CODES[number];

/**
 * Plural forms keyed by the CLDR categories `Intl.PluralRules` selects.
 *
 * Only `other` is required: a language that does not distinguish a category
 * simply omits it and falls back. English needs `one`/`other`, Russian also
 * needs `few` and `many`, Kazakh and Spanish need `one`/`other`.
 */
export interface PluralMessage {
    zero?: string;
    one?: string;
    two?: string;
    few?: string;
    many?: string;
    other: string;
}

export type Message = string | PluralMessage;

/** Every key the interface can ask for, derived from the English catalogue. */
export type MessageKey = keyof typeof en;

/** A complete translation. Missing or unknown keys are compile errors. */
export type Messages = Record<MessageKey, Message>;

/** Values substituted into `{placeholders}`; `count` also selects the plural. */
export type MessageVars = Record<string, string | number>;
